//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { convertTime } from '../../../components/helpers.js'
import { axiosGet, axiosPost } from '../../../axios/axios.js'
import WaybillCommentAdd from './WaybillCommentAdd.vue'
import { setResizeColumnTable } from './TableColumnResize.js'
import manba from 'manba'

export default {
  components: {
    WaybillCommentAdd
  },
  props: {
    comments: {
      type: Array,
      default: function () {
        return []
      }
    },
    type: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loading: false,
      pagination: {
        rowsPerPage: 0
      },
      confirmRemove: false,
      columns: [
        {
          name: 'comment',
          label: 'Текст',
          align: 'left',
          field: 'comment',
          sortable: false,
          headerClasses: 'comment-text'
        },
        {
          name: 'time',
          label: 'Дата/время создания',
          align: 'left',
          field: 'time',
          sortable: true,
          format: convertTime
        },
        {
          name: 'fio',
          label: 'Пользователь',
          align: 'left',
          field: 'fio',
          sortable: false
        }
      ],
      defaultComments: [],
      defaultResize: false,
      selectRemoveRecord: null
    }
  },
  watch: {
    comments: {
      handler: function (t) {
        if (!this.defaultResize && t.length) {
          this.defaultResize = true
          setResizeColumnTable()
        }
      },
      immediate: true
    }
  },
  created: function () {
    this.getDefaultComments()
  },
  methods: {
    getTextLabel: function () {
      let label = ''
      switch (this.type) {
        case 'start':
          label = 'Комментарии при создании рейса '
          break
        case 'close':
          label = 'Комментарии при закрытии рейса '
          break
        case 'startVJ':
          label = 'Комментарии при выдаче ТС '
          break
        case 'closeVJ':
          label = 'Комментарии при сдаче ТС '
          break
        case 'inside':
          label = 'Комментарии в процессе рейса '
          break
        default:
          break
      }
      return label
    },
    getDefaultComments: function () {
      this.loading = true
      const params = [{ param: 'orderNumber', type: 'integer', action: 'any' }, { param: 'commentText', type: 'string', action: 'any' }]

      let paramType = 'showAtRide'
      switch (this.type) {
        case 'start':
          paramType = 'showAtDeparture'
          break
        case 'close':
          paramType = 'showAtReturn'
          break
        case 'startVJ':
          paramType = 'showAtDeparture'
          break
        case 'closeVJ':
          paramType = 'showAtReturn'
          break
        case 'inside':
          paramType = 'showAtRide'
          break
        default:
          break
      }
      params.push({ param: paramType, type: 'boolean', action: '=', value: true })

      const encodeParams = encodeURI(JSON.stringify(params))

      const type = 'vehicleDepartureRideReturnComment'

      axiosGet({
        url: '/service/obj/search?params=' + encodeParams + '&nameField=name&paramsOperation=and&type=' + type + '&limit=1000&sort=param.orderNumber&dir=ASC',
        onSuccess: (response) => {
          this.defaultComments = response.data.result
        },
        onFailure: 'Ошибка загрузки списка доступных шаблонов',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    openAdd: function () {
      this.$nextTick(() => {
        this.$refs.modalAddComment.opened = true
        this.$refs.modalAddComment.typeComment = this.type
        this.$refs.modalAddComment.defaultComments = this.defaultComments
        this.$refs.modalAddComment.comment = null
        this.$refs.modalAddComment.selectedDefaultComment = null
      })
    },
    setComment: function (comment) {
      this.$nextTick(() => {
        const user = this.$store.getters.getUser
        this.comments.push({ comment: comment, time: (new Date()).getTime(), fio: user.name })
        this.$emit('update-waybill-comments', { commentsList: this.comments, type: this.type })
      })
    },
    onRemove: function (obj) {
      this.$nextTick(() => {
        this.confirmRemove = true
        this.selectRemoveRecord = obj
      })
    },
    onRemoveRecord: function () {
      const obj = this.selectRemoveRecord
      this.$nextTick(() => {
        const arrComments = this.comments.filter(function (item) {
          return !(item.comment == obj.comment && item.time == obj.time && item.fio == obj.fio)
        })
        this.confirmRemove = false
        this.$emit('update-waybill-comments', { commentsList: arrComments, type: this.type })
      })
    },
    formatInitials: function (name) {
      if (!name) {
        return ''
      }
      const arrFullName = name.split(' ')
      return arrFullName[0] + ' ' +
             (arrFullName[1] ? (arrFullName[1].substring(0, 1) + '.') : '') + ' ' +
             (arrFullName[2] ? (arrFullName[2].substring(0, 1) + '.') : '')
    },
    formatDateTime: function (time) {
      return time ? manba(time).format('DD-MM-YYYY HH:mm') : ''
    },
    setCommentsService: function (id, type, commentsList) {
      const urlName = type == 'inside' ? '/service/delta/waybill/setComments' : '/service/delta/journal/vehicleIssuance/setComments'

      const bodyFormData = new FormData()
      const arrComments = commentsList.map(function (e) {
        return e.user ? { comment: e.comment, user: e.user, time: e.time } : { comment: e.comment }
      })
      bodyFormData.set('comments', JSON.stringify(arrComments))
      bodyFormData.set('id', id)

      this.loading = true
      return axiosPost({
        url: urlName,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.$emit('update-after-add-comments', { comments: response.data.comments, type: type })
          this.$q.notify({
            type: 'positive',
            message: 'Комментарии успешно обновлены!',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
